import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UnitsDropDownEvent } from '@app/mpp/model/ingredient-card-click-event';
import { cleanServingValue } from '@app/mpp/pages/recipe-detail/helper/recipe-detail-helper';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-ingredient-units-of-measure',
  templateUrl: './ingredient-units-of-measure.component.html',
  styleUrls: ['./ingredient-units-of-measure.component.scss'],
})
export class IngredientUnitsOfMeasureComponent {
  @Input() platform: PlatformEnum;
  @Input() baseUnit: string;
  @Input() baseQuantity: number;
  @Input() conversionUnit: string;
  @Input() conversionQuantity: number;
  @Input() solvedUnit: string;
  @Input() solvedQuantity: number;
  @Input() solvedCost: number;
  @Input() baseUnits: string[];
  @Input() conversionUnits: string[];
  @Input() disableInputs: boolean;
  @Input() hidePricing: boolean;
  @Input() hideSaving: boolean;
  @Input() inLinePadding: boolean;
  @Input() lockEdits: boolean;
  @Output() baseQuantityEvent = new EventEmitter<number>();
  @Output() conversionQuantityEvent = new EventEmitter<number>();
  @Output() baseUnitEvent = new EventEmitter<UnitsDropDownEvent>();
  @Output() conversionUnitEvent = new EventEmitter<UnitsDropDownEvent>();
  @Output() resultUnitEvent = new EventEmitter<UnitsDropDownEvent>();
  @Output() saveChangesEvent = new EventEmitter<void>();
  @Output() infoIconEvent = new EventEmitter<Event>();

  platformRef = PlatformEnum;
  constructor() {}

  clickBaseUnit(event: Event) {
    this.baseUnitEvent.emit({ event, options: this.baseUnits });
  }

  clickConversionUnit(event: Event) {
    this.conversionUnitEvent.emit({ event, options: this.conversionUnits });
  }

  clickResultUnit(event: Event) {
    this.resultUnitEvent.emit({ event, options: this.baseUnits });
  }

  updateBaseQunatity(value: string) {
    const adjustedVal = cleanServingValue(value);
    this.baseQuantityEvent.emit(adjustedVal);
  }

  updateConversionQuantity(value: string) {
    const adjustedVal = cleanServingValue(value);
    this.conversionQuantityEvent.emit(adjustedVal);
  }

  saveUnitsOfMeasureCalculation = () => {
    if (
      !!this.baseQuantity &&
      !!this.conversionQuantity &&
      !!this.baseUnit &&
      !!this.conversionUnit
    )
      this.saveChangesEvent.emit();
  };

  hoverInfoIcon = ($event: Event) => {
    this.infoIconEvent.emit($event);
  };
}
